import { SVGProps } from 'react';

const SvgPackagePlusMonochrome = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M6.817 7.331a2.285 2.285 0 0 1 2.368.002l.02.012 2.834 1.813-1.078 1.684-2.82-1.803A.283.283 0 0 0 8 9c-.049 0-.1.013-.148.043l-.004.002-4.664 2.8a.369.369 0 0 0-.129.137A.455.455 0 0 0 3 12.2v5.6c0 .08.02.154.055.218a.37.37 0 0 0 .129.138h.001l4.667 2.801c.048.03.1.043.148.043.049 0 .1-.013.148-.043l.004-.002 4.663-2.798.001-.001a.37.37 0 0 0 .129-.138A.456.456 0 0 0 13 17.8v-5.6h2v5.6c0 .412-.104.82-.303 1.182-.2.362-.49.669-.845.885l-.004.002-4.663 2.799h-.002a2.284 2.284 0 0 1-2.366 0h-.002l-4.663-2.799-.004-.002a2.368 2.368 0 0 1-.845-.885A2.455 2.455 0 0 1 1 17.802v-5.603c0-.411.104-.82.303-1.181.2-.362.49-.669.845-.885l.004-.002 4.665-2.8Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="m7.553 15.894-6-3 .894-1.788L8 13.882l5.553-2.776.894 1.788-6 3a1 1 0 0 1-.894 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M8 14a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1ZM15.5 16a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0-10.89c.319 0 .577.259.577.577v2.236h2.235a.577.577 0 0 1 0 1.154h-2.235v2.236a.577.577 0 0 1-1.154 0V9.076h-2.236a.577.577 0 0 1 0-1.154h2.236V5.687c0-.318.258-.576.577-.576Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgPackagePlusMonochrome;
